export default __webpack_public_path__ + "static/media/fish_oil4.563be696.png";